import { hot } from 'react-hot-loader/root'; //als eerste
import React, { StrictMode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import PageHeader from "./layout/PageHeader";
import PageContent from "./layout/PageContent";
import ExceptionPage from "./exception/ExceptionPage";
import SideNav from "./layout/SideNav";
import Beads from "./layout/Beads";
import generateGuid from "../util/guid";
import { Dimmer } from "semantic-ui-react";
import Loader from "./common/Loader";

import { getRoutes } from "../components/Navigation";

class App extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			showStatusPopup: false
		};
	}

	componentDidMount() {
		this.updateBodyBackground(this.props.location?.pathname);
	}

	componentDidUpdate(prevProps) {
		if (this.props.location?.pathname !== prevProps.location?.pathname) {
			this.updateBodyBackground(this.props.location?.pathname);
		}
	}

	updateBodyBackground(pathname) {
		let color = "#F3F8FD";

		if (pathname && pathname.includes("/zoekmotor/")) {
			color = "white";
		}

		document.body.style.backgroundColor = color;
	}

	render() {
		const onClickStatusButton = () => {
			this.setState({
				showStatusPopup: true
			});
			window.parent.scrollTo(0, 10);
		};
		const confirmStatusPopup = () => {
			this.setState({
				showStatusPopup: false
			});
		};
		const { showHeader, showTopNav, showSideNav, showBeads, loading, pageHeaderTitle, pageHeaderSubtitle, exception, topNavTabSettings, scope, match, redenVanStatus, svlDossierId } = this.props;
		return (
			// <StrictMode>
			<div>
				<ExceptionPage exception={exception}>
					<Dimmer active={loading} page><Loader /></Dimmer>
					{showHeader ? <PageHeader showTopNav={showTopNav} title={pageHeaderTitle} intro={pageHeaderSubtitle} topNavTabSettings={topNavTabSettings} scope={scope} subTitle={svlDossierId} /> : null}
					<PageContent id="modal-holder_pageconten" loading={loading}>
						{showSideNav ? <SideNav key={generateGuid()} /> : null}
						{showBeads ? <Beads state={this.state} onClickStatusButton={onClickStatusButton} confirmStatusPopup={confirmStatusPopup} showStatusPopup={this.state.showStatusPopup} redenVanStatus={redenVanStatus} /> : null}
						{getRoutes(match)}
					</PageContent>
					<div id="modal-holder"></div>
				</ExceptionPage>
			</div>
			// </StrictMode>
		);
	}
}

App.propTypes = {
	loading: PropTypes.bool.isRequired,
	showHeader: PropTypes.bool.isRequired,
	showTopNav: PropTypes.bool.isRequired,
	topNavTabSettings: PropTypes.object.isRequired,
	showSideNav: PropTypes.bool.isRequired,
	showBeads: PropTypes.bool.isRequired,
	pageHeaderSubtitle: PropTypes.string,
	pageHeaderTitle: PropTypes.node.isRequired,
	exception: PropTypes.object,
	scope: PropTypes.string.isRequired,
	match: PropTypes.object.isRequired,
	redenVanStatus: PropTypes.number,
	svlDossierId: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
	return {
		loading: state.ajaxCounter > 0,
		showHeader: state.layout.showHeader,
		showTopNav: state.layout.showTopNav,
		topNavTabSettings: state.layout.showSportkampenLayout ? state.layout.sportkampenTopNavTabSettings : state.layout.topNavTabSettings,
		showSideNav: state.layout.showSideNav,
		showBeads: state.layout.showBeads,
		pageHeaderTitle: state.layout.pageHeaderTitle,
		pageHeaderSubtitle: state.layout.pageHeaderSubtitle,
		exception: state.exception,
		scope: state.layout.scope,
		validatieStatussen: state.validatieStatussen,
		redenVanStatus: state.layout.redenVanStatus,
		svlDossierId: state.layout.svlDossierId
	};
}

export default hot(connect(mapStateToProps)(App));

